import LaporanService from '@/services/laporan';

export default {
	namespaced: true,
	state: {
	},

	getters: {
	},

	actions: {
		async getLaporan({ commit, state, getters, dispatch }, payload) {
			try {
				const response = await LaporanService.laporan({
					...payload
				})

				return response
			} catch (e) {
				console.log(e)
			}
		},
		async printLaporan({ commit, state, getters, dispatch }, payload) {
			try {
				const response = await LaporanService.printLaporan({
					...payload
				})

				return response
			} catch (e) {
				console.log(e)
			}
		},
	},

	mutations: {
	}
};
